import React from 'react';

import styled from '@emotion/styled';

interface CustomerInfoCardProps {
  data: any;
}
const CustomerInfoCard: React.FC<CustomerInfoCardProps> = ({ data }) => {
  return (
    <Container>
      <NameArea>{data.name ?? 'No Name'}</NameArea>
      <EmailArea>{data.email}</EmailArea>
    </Container>
  );
};

export default CustomerInfoCard;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
`;

const NameArea = styled.div`
  font-size: 14px;
`;

const EmailArea = styled.div`
  font-size: 12px;
`;
